// import request from '@/utils/request'
import axios from 'axios'

// 上传图片
export function upload(data) {
  const formData = new FormData()
  formData.append('file', data.file)
  return axios.post(window.baseUrlConfig.VUE_APP_OTHER_API + '/upload/file',
    formData
  )
}

// 压缩图片
export function compress(file) {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  return new Promise((resolve, reject) => {
    reader.onload = function() {
      const content = this.result // 图片的src，base64格式
      const img = new Image()
      img.src = content
      img.onload = () => { // 图片加载完毕
        resolve(compressEvent(img))
      }
    }
  })
}

function compressEvent(img) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const width = img.width
  const height = img.height
  canvas.width = width
  canvas.height = height
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, width, height)
  ctx.drawImage(img, 0, 0, width, height)
  const dataURL = canvas.toDataURL('image/jpeg', 0.3)
  return { dataURL, blob: dataURItoBlob(dataURL) }
}

function dataURItoBlob(dataurl) { // dataurl是base64格式
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}
